import { on_swiper_ready } from 'js/utils';

function init(){
    const el = document.querySelector('.home_banner_carousel .swiper');
    on_swiper_ready(el, ()=>update_swiper(el))
}
init();

function update_swiper(el){
    el.swiper.params.effect = 'fade';
    el.swiper.params.fadeEffect = {
        crossFade: true,
    };
    el.swiper.update();
}